import { type FC } from "react";

import { type SpecApprovalState } from "../../../../gql-generated/types";
import { LensStatusIndicator, LensesStatusTitle } from "../../../../lens/components/shared";
import { mapApiStatus } from "../../../utils";

interface ApiStatus {
    status: SpecApprovalState;
}

export const ApiStatusBadge: FC<ApiStatus> = ({ status }) => {
    const { name, color } = mapApiStatus(status);

    return (
        <LensesStatusTitle>
            <LensStatusIndicator background={color} />
            {name}
        </LensesStatusTitle>
    );
};
